import { render, staticRenderFns } from "./HubSwitch.vue?vue&type=template&id=2b36ecb0&scoped=true&"
import script from "./HubSwitch.vue?vue&type=script&lang=ts&"
export * from "./HubSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./HubSwitch.vue?vue&type=style&index=0&id=2b36ecb0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b36ecb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
